import { render } from "./ContactFile.vue?vue&type=template&id=5c7cbae3&scoped=true"
import script from "./ContactFile.vue?vue&type=script&lang=ts"
export * from "./ContactFile.vue?vue&type=script&lang=ts"

import "./ContactFile.vue?vue&type=style&index=0&id=5c7cbae3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5c7cbae3"

export default script